.logo {
  font-family: 'CaviarDreams';
  font-weight: 500;
  font-size: 2.1em;
  text-align: center;
}

.logo.sm {
  font-size: 1.5em;
}

.logo.md {
  font-size: 2.1em;
}

.logo.lg {
  font-size: 2.7em;
}

.abc {
  color: var(--mantine-color-brand-4);
}
